import { Spinner } from '@/shared/ui/spinner';

export function FullPageLoader() {
  return (
    <div role="status" className="flex min-h-screen items-center justify-center bg-bg text-muted">
      <Spinner size="lg" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
